import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub';
import Input from 'components/Input';
import DrawerStars from './DrawerStars';
import Loader from 'components/Loader';
import ReviewsServices from 'services/Reviews';
import TagManagerService from 'services/TagManager';
import InputText from 'components/Forms/Inputs/InputText';
import style from './style.scss';


let isvalid = '';
//let firstNameValid = false;
// let summaryValid = false;
let starsValid = false;
// let commentValid = false
let stars = false;

const WriteReview = ({_close, productId, itemId}) => {
    //const [firstNameValue, setFirstNameValue] = useState('');
    const [summaryValue, setSummaryValue] = useState('');
    const [addNote, setAddNote] = useState('');
    const [formIsValid, setFormIsValid] = useState(false);
    const [loader, setLoader] = useState(false);

    //let firstName = useRef('');
    let summaryPhrase = useRef('');

    useEffect(() => {
        return function cleanup() {
            //firstNameValid = false;
            // summaryValid = false;
            starsValid = false;
            // commentValid = false
            stars = false;
        }
    }, [])

    const _getStarsValid = (isValid, value) => {
        starsValid = isValid;
        stars = value
    }
    
    // const _getNameValid = (isValid) => {
    //     setFirstNameValue(firstName.current.value);
    //     firstNameValid = isValid;
    // }

    const _getSummaryValid = () => {
        setSummaryValue(summaryPhrase.current.value)
        // summaryValid = isValid
    }

    const validateInput = (value) => {
        return typeof(value) === 'string' && value.trim().length >= 1;
    }

    const characterLimit = (name, validate, value) => {
        const textValue = value;
        setAddNote(textValue);

        validateInput(textValue);
        validateForm();
    }

    const validateForm = () => {
        // && summaryValue && addNote
        if (stars) {
            // && summaryValid && commentValid
            isvalid =  starsValid;
            setFormIsValid(isvalid)

        } else {
            setFormIsValid(false)
        }
    }

    const submit = () => {
        if(loader) return null;
        setLoader(true)
        ReviewsServices.addReviewProduct(productId, stars , summaryValue, addNote).then((result) => {
            if(result && !result.status) {
                setTimeout(()=> _close(true), 300);
                setTimeout(() => {
                    PubSub.dispatch('open_snackbar', {
                        Subtitle: '¡Calificación enviada! Antes de publicarla, la revisaremos',
                        timer: 5000,
                        type: 'sendReview',
                    })
                }, 0)
            }
            setLoader(false);
            TagManagerService.interaction('Escribir comentario (enviar)', itemId,  'PDP -Reviews');
        })
    }

    return (
        <div className={'drawer-container'}>
            <h1 className="drawer-title">Agregar calificación</h1>
            <div className={'drawer-scroll content-review'}>
                {loader && <div className="loader-review"><Loader/></div>}
                <div className="general-ranking">
                    <div className="general-ranking-title">Calificación general</div>
                    <DrawerStars validateForm={validateForm} validateInput={validateInput} _getStarsValid={_getStarsValid}/>
                </div>

                {/* <div className="drawer-input-name-wrap">
                    <div className="drawer-input-title-wrap">
                        <span className="drawer-input-title">Nombre</span>
                        <span className="drawer-input-required">Obligatorio</span>
                    </div>

                    <Input
                        ref={firstName}
                        key={'name'}
                        className={'drawer-review-input'}
                        name={'name'}
                        type={'text'}
                        value={firstNameValue}
                        onChange={validateInput}
                        helpText=""
                        size=""
                        placeholder={'Ejemplo: Francisca'}
                        message={{
                            "error": "Campo obligatorio"
                        }}
                        validateForm={validateForm}
                        callbackValidate={_getNameValid}
                    />
                </div> */}

                <div className="drawer-input-summary-phrase-wrap">
                    <div className="drawer-input-title-wrap">
                        <span className="drawer-input-title">Escribe una frase de resumen</span>
                    </div>

                    <Input
                        ref={summaryPhrase}
                        key={'summary'}
                        className={'drawer-review-input'}
                        name={'summary'}
                        type={'text'}
                        value={summaryValue}
                        onChange={validateInput}
                        helpText=""
                        size=""
                        message={{}}
                        validateForm={validateForm}
                        callbackValidate={_getSummaryValid}
                    />
                </div>

                <div className="drawer-input-comment-wrap">
                    <div className="drawer-input-title-wrap">
                        <span className="drawer-input-title">Comentario</span>
                    </div>

                    <div className={"drawer-review-textarea-wrap"}>

                        <InputText 
                            label={''}
                            required={false}
                            placeholder={'Opina sobre características, calidad o detalles del producto.'} 
                            className={"drawer-review-textarea"}
                            textArea={true}
                            maxLength={150}
                            defaultValue={addNote}
                            type={'text'}
                            callbackOnChange={characterLimit}
                            callbackValidate={() => { return true}}
                            message={{
                                'error': 'error',
                            }}
                            counter={true}
                        />
                    </div>
                </div>
            </div>
            <div className="drawer-actions">
                <button type="button" className="secundary-btn drawer-reviews-back" onClick={() =>_close(false)} >Volver</button>
                <button onClick={submit} className={((formIsValid && !loader) ? ' primary-btn ' : ' disabled-btn ') + ' drawer-reviews-send '}>Enviar</button>
            </div>
        </div>
    )
}

WriteReview.propTypes = {
    _close: PropTypes.func,
    itemId : PropTypes.string
}

export default WriteReview; 